import { SET_LOADING_BLOCK_LIST } from 'root/src/client/logic/list/actionIds'

export default (payload, moduleId) => ({
	type: SET_LOADING_BLOCK_LIST,
	payload: { payload, moduleId },
})
